import { defineMessages } from 'react-intl';

export default defineMessages({
  readMore: {
    id: 'Read more',
    defaultMessage: 'Read more',
  }
});
